import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getShiftTypeCompanies,
  deleteShiftTypeCompany,
} from "../actions/shiftTypeCompanyActions";

import DataListWithSearchFilter from "./DataListWithSearchFilter";
import formatPrice from "../utils/format-price";

class ShiftTypeCompaniesList extends Component {
  state = {
    shiftTypeCompanies: [],
  };

  componentDidMount() {
    this.props
      .getShiftTypeCompanies(this.props.shiftTypeId)
      .then((shiftTypeCompanies) => {
        this.setState({ shiftTypeCompanies });
      });
  }

  deleteShiftTypeCompany(shiftTypeId, companyEmail) {
    this.props.deleteShiftTypeCompany(shiftTypeId, companyEmail).then(() => {
      this.setState({
        shiftTypeCompanies: this.state.shiftTypeCompanies.filter(
          (c) => c.email != companyEmail,
        ),
      });
    });
  }

  render() {
    return (
      <DataListWithSearchFilter
        data={this.state.shiftTypeCompanies.map((company) => {
          return {
            id: company.email,
            title: company.name,
            subtitle: formatPrice(company.ShiftTypeCompany.price),
            ctxMenu: [
              {
                label: "Wijzigen",
                action: () =>
                  (window.location.href = `/shifttype/${this.props.shiftTypeId}/company/${company.email}/update`),
              },
              {
                label: "Verwijderen",
                action: () =>
                  this.deleteShiftTypeCompany(
                    this.props.shiftTypeId,
                    company.email,
                  ),
                confirm: true,
              },
            ],
          };
        })}
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      />
    );
  }
}

ShiftTypeCompaniesList.propTypes = {
  shiftTypeId: PropTypes.string.isRequired,
  getShiftTypeCompanies: PropTypes.func.isRequired,
  deleteShiftTypeCompany: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage:
    state.shiftTypeCompany.getShiftTypeCompanies.successMessage ||
    state.shiftTypeCompany.deleteShiftTypeCompany.successMessage,
  errorMessage:
    state.shiftTypeCompany.getShiftTypeCompanies.errorMessage ||
    state.shiftTypeCompany.deleteShiftTypeCompany.errorMessage,
  isFetching:
    state.shiftTypeCompany.getShiftTypeCompanies.isFetching ||
    state.shiftTypeCompany.deleteShiftTypeCompany.isFetching,
});

export default connect(mapStateToProps, {
  getShiftTypeCompanies,
  deleteShiftTypeCompany,
})(ShiftTypeCompaniesList);



// WEBPACK FOOTER //
// ./src/components/ShiftTypeCompaniesList.js